import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { useFormattingContext } from '../../../../FormattingProvider/FormattingContext'
import { useVisualBlocksContext } from '../VisualBlocksContext'

function SplitListItemSubtotal ({ item }) {
  const { formatter } = useFormattingContext()
  const { formats, styles, classNames } =
    useVisualBlocksContext()
  const formatString = formats?.listItems ?? 'money'
  const itemStyles = styles?.listItems || {}
  const itemClassNames = classNames?.listItems ?? ''

  return (
    <div
      className={clsx(
        'flex flex-1 gap-1 relative justify-end items-center font-size-xs p-2 bg-neutral-100 bold',
        itemClassNames
      )}
      style={{ ...itemStyles }}
    >
      <div>{formatter(item.value, formatString)}</div>
    </div>
  )
}

SplitListItemSubtotal.propTypes = {
  item: PropTypes.object.isRequired
}

export default SplitListItemSubtotal
